/* eslint-disable jira/filename-case */

import { fg } from '@atlassian/jira-feature-gating';
import {
	// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router
	createResource,
	type Match,
	type Query,
	type RouteResource,
} from '@atlassian/react-resource-router';
import { getProjectKeyId } from '@jira/router-resources__utils/src/getProjectKeyId.tsx';
import { safeCloneResource } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { fetchShortcuts } from '../../../services/sidebar/index.tsx';
import type { ProjectShortcut } from '../../../types.tsx';

const getIdentifier = (match: Match, query: Query): string => {
	const { projectKey, projectId } = getProjectKeyId(match, query);
	return projectKey || projectId;
};

/**
 * @deprecated Do not use this resource, instead fetch data in your component directly.
 */
export const staticSidebarShortcutsResource: RouteResource<ProjectShortcut[] | null> =
	safeCloneResource(
		createResource<ProjectShortcut[] | null>({
			type: 'NAVIGATION_SIDEBAR_PROJECT_SHORTCUTS',
			// oxlint-disable-next-line no-explicit-any
			getKey: ({ match, query }: { match: any; query: any }) =>
				getIdentifier(match, query) ?? 'none',
			getData: async ({ match, query }) => {
				const projectKeyOrId = getIdentifier(match, query);
				if (projectKeyOrId == null) {
					return null;
				}
				const shortcuts = await fetchShortcuts(projectKeyOrId);
				return shortcuts;
			},
			maxAge: 5 * 60 * 1000,
		}),
		{
			get isPageShellCritical() {
				return !fg('jira_ssr_demote_optional_critical_resources');
			},
		},
	);
